import { render, staticRenderFns } from "./EmployeePersonalInformation.vue?vue&type=template&id=f54388c6&"
import script from "./EmployeePersonalInformation.vue?vue&type=script&lang=js&"
export * from "./EmployeePersonalInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f54388c6')) {
      api.createRecord('f54388c6', component.options)
    } else {
      api.reload('f54388c6', component.options)
    }
    module.hot.accept("./EmployeePersonalInformation.vue?vue&type=template&id=f54388c6&", function () {
      api.rerender('f54388c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/hrmanagement/EmployeeManagement/EmployeeDetails/EmployeePersonalInformation.vue"
export default component.exports